import { useFormikContext } from "formik";
import { FC } from "react";

import Checkbox from "web/Components/Common/Form/Checkbox";

import { RentableGroupCalculatorCopy } from "../const/rentableGroupCalculatorCopy";
import RentableGroupCalculatorHtmlContent from "../RentableGroupCalculatorHtmlContent";
import type {
  IRentableGroupCalculatorValues,
  Statements,
} from "../rentableGroupCalculatorContainer";
import shouldDisableCheckbox from "../utils/shouldDisableCheckbox";
import classes from "./rentableGroupCalculatorStatements.scss";

interface IRentableGroupCalculatorStatementsProps {
  statements: Statements;
  calculatorCopy: RentableGroupCalculatorCopy;
}

const RentableGroupCalculatorStatements: FC<
  IRentableGroupCalculatorStatementsProps
> = ({ statements, calculatorCopy }) => {
  const { values } = useFormikContext<IRentableGroupCalculatorValues>();
  const { fillCalculatorCheckbox, financingCheckbox } = calculatorCopy || {};
  const statementsContent = {
    "fill-calculator-checkbox": fillCalculatorCheckbox,
    "financing-checkbox": financingCheckbox,
  };
  
  return (
    <section className={classes.root}>
      {statements?.map((statement) => (
        <Checkbox
          key={statement}
          classes={{ root: classes.checkbox }}
          name={statement}
          isDisabled={shouldDisableCheckbox(values, statements, statement)}
        >
          <RentableGroupCalculatorHtmlContent
            className={classes.checkboxContent}
            as="span"
            html={
              statementsContent[statement as keyof typeof statementsContent]
            }
          />
        </Checkbox>
      ))}
    </section>
  );
};

export default RentableGroupCalculatorStatements;
